import React from "react";

const AccessoryEmptyState = ({ state, onRetry, onClear, canClear }) => {
  if (!state) return null;

  return (
    <div className={`acc-empty acc-empty-${state.kind}`} role="status">
      <h2>{state.title}</h2>
      <p>{state.body}</p>

      <div className="acc-empty-actions">
        {state.retry && (
          <button type="button" className="acc-empty-action" onClick={onRetry}>
            Retry
          </button>
        )}

        {!state.retry && canClear && (
          <button type="button" className="acc-empty-action" onClick={onClear}>
            Clear filters
          </button>
        )}
      </div>
    </div>
  );
};

export default AccessoryEmptyState;
